import {main_phaser} from "../framework/src/engine/madnes/MadnesApp";
import {madnes_set_win_factors} from "../framework/src/engine/madnes/madnes";
import {
    madnes_add_child,
    madnes_add_group,
    madnes_add_img,
    madnes_add_sprite,
    madnes_add_to_group, madnes_set_alpha, madnes_set_img_center, madnes_set_pos, madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {he, multi, picture_convert, reels_lenghts, reels_pos, wi, server_config, behavior_config} from "../framework/src/engine/madnes/madnes_variables";
import {stopposin, stopposin_old} from "./turbo27_core";
import {cylinder_pos} from "./adapters/madnesGameAdapter";
import {madnes_add_bitmap_text} from "../framework/src/engine/madnes/madnes_text";
import {madnes_anim_add, madnes_generate_frame_names} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_audio_allow_multiple} from "../framework/src/engine/madnes/madnes_audio";
import {hide_all_lines} from "./turbo27_core_res_ctrl";

export function t27_print_desk()
{
    // set_sounds();

    if(typeof behavior_config.reel.spin.motionBlur == "undefined")
    {
        behavior_config.reel.spin.motionBlur = 1;
    }

    if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
    }

    if(typeof behavior_config.reel.brake.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
    }

    madnes_set_win_factors(
        behavior_config.reel.minBigWinFactor,
        behavior_config.reel.minMegaWinFactor,
        behavior_config.reel.minSuperMegaWinFactor
    );

//	if( typeof server_config.logic !== "undefined" &&
//		typeof server_config.logic.bet_set !== "undefined" )
//	{
//		//madnes_init_bets(server_config.logic.bet_set);
//	}

    madnes_add_img("background", "background", 0, 0);

    for(var i = 0; i < cylinder_pos.length; i++)
    {
        madnes_add_group("reel_group_" + i);

        for(var j = 0; j < 5; j++) {

            var bgSpriteName = "reels_bufer_" + i + "_" + j + "_BG";

            madnes_add_sprite(bgSpriteName, "freespins_reels", cylinder_pos[i], -9999);
            madnes_add_to_group("reel_group_" + i, bgSpriteName);
        }

        for(var j in server_config.logic.reels[i])
        {
            var symbolName = get_reel_symbol_name(server_config.logic.reels, i, j);

            madnes_add_img("reels_bufer_"+i+"_"+j, symbolName + "_blur", cylinder_pos[i], -9999);
            //madnes_sprite_set_frame("reels_bufer_"+i+"_"+j, 1);

            reels_lenghts[i] = j * 1 + 1;
            stopposin[i] = reels_lenghts[i];
            stopposin_old[i] = reels_lenghts[i];
        }

        // S0-S2 = priprava vyherni pozice na kazdem valci
        madnes_add_sprite("reels_bufer_"+i+"_S0", get_reel_symbol_name(server_config.matrix.reelMatrix, i, 2), cylinder_pos[i], -9999);
        madnes_add_sprite("reels_bufer_"+i+"_S1", get_reel_symbol_name(server_config.matrix.reelMatrix, i, 1), cylinder_pos[i], -9999);
        madnes_add_sprite("reels_bufer_"+i+"_S2", get_reel_symbol_name(server_config.matrix.reelMatrix, i, 0), cylinder_pos[i], -9999);

        reels_pos[i] = 0;

        madnes_add_to_group("reel_group_" + i, "reels_bufer_"+i+"_S0");
        madnes_add_to_group("reel_group_" + i, "reels_bufer_"+i+"_S1");
        madnes_add_to_group("reel_group_" + i, "reels_bufer_"+i+"_S2");
    }

    madnes_add_img("cover", "reels_cover", 0, 0);

    var winlineX = 139;
    var winlineYTop = 226;
    var winlineYCenter = 393;
    var winlineYBottom = 561;

    madnes_add_img("winline_1", "winline_1", winlineX, winlineYTop);
    madnes_add_img("winline_2", "winline_2", winlineX, winlineYTop);

    madnes_add_img("winline_3", "winline_3", winlineX, winlineYTop);
    madnes_add_img("winline_4", "winline_4", winlineX, winlineYTop);
    madnes_add_img("winline_5", "winline_5", winlineX, winlineYTop);

    madnes_add_img("winline_6", "winline_6", winlineX, winlineYTop);
    madnes_add_img("winline_7", "winline_7", winlineX, winlineYTop);
    madnes_add_img("winline_8", "winline_8", winlineX, winlineYTop);

    madnes_add_img("winline_9", "winline_9", winlineX, winlineYTop);
    madnes_add_img("winline_10", "winline_10", winlineX, winlineYTop);
    madnes_add_img("winline_11", "winline_11", winlineX, winlineYTop);

    madnes_add_img("winline_12", "winline_12", winlineX, winlineYTop);
    madnes_add_img("winline_14", "winline_14", winlineX, winlineYCenter);

    madnes_add_img("winline_15", "winline_15", winlineX, winlineYTop);
    madnes_add_img("winline_16", "winline_16", winlineX, winlineYCenter);
    madnes_add_img("winline_17", "winline_17", winlineX, winlineYCenter);

    madnes_add_img("winline_18", "winline_18", winlineX, winlineYTop);
    madnes_add_img("winline_19", "winline_19", winlineX, winlineYTop);
    madnes_add_img("winline_20", "winline_20", winlineX, winlineYTop);

    madnes_add_img("winline_21", "winline_21", winlineX, winlineYTop);
    madnes_add_img("winline_22", "winline_22", winlineX, winlineYCenter);
    madnes_add_img("winline_23", "winline_23", winlineX, winlineYCenter);

    madnes_add_img("winline_24", "winline_24", winlineX, winlineYTop);
    madnes_add_img("winline_25", "winline_25", winlineX, winlineYCenter);

    madnes_add_img("winline_0", "winline_0", winlineX, winlineYTop);
    madnes_add_img("winline_13", "winline_0", winlineX, winlineYCenter);
    madnes_add_img("winline_26", "winline_0", winlineX, winlineYBottom);

    hide_all_lines();

    for(var i = 0; i < cylinder_pos.length; i++)
    {
        madnes_add_img("winframe_" + i + "_0", "winframe", -9999, -9999);
        madnes_add_img("winframe_" + i + "_1", "winframe", -9999, -9999);
        madnes_add_img("winframe_" + i + "_2", "winframe", -9999, -9999);

        madnes_add_sprite("reels_bufer_" + i + "_TMP0", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
        madnes_add_sprite("reels_bufer_" + i + "_TMP1", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
        madnes_add_sprite("reels_bufer_" + i + "_TMP2", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
    }

    madnes_add_img("ring_left_win_2", "ring_left_win", 53, 191);
    madnes_set_visible("ring_left_win_2", false);

    madnes_add_img("ring_left_win_1", "ring_left_win", 53, 357);
    madnes_set_visible("ring_left_win_1", false);

    madnes_add_img("ring_left_win_0", "ring_left_win", 53, 523);
    madnes_set_visible("ring_left_win_0", false);

    madnes_add_img("ring_right_win_2", "ring_right_win", 1083, 191);
    madnes_set_visible("ring_right_win_2", false);

    madnes_add_img("ring_right_win_1", "ring_right_win", 1083, 357);
    madnes_set_visible("ring_right_win_1", false);

    madnes_add_img("ring_right_win_0", "ring_right_win", 1083, 523);
    madnes_set_visible("ring_right_win_0", false);

    madnes_add_img("win27_left_2", "win27", 87, 205);
    madnes_add_img("win27_left_1", "win27", 87, 372);
    madnes_add_img("win27_left_0", "win27", 87, 538);

    madnes_add_img("win27_right_2", "win27", 1115, 205);
    madnes_add_img("win27_right_1", "win27", 1115, 372);
    madnes_add_img("win27_right_0", "win27", 1115, 538);

    hide_all_27();

    var shiftBigWinX = 0;
    var shiftBigWinY = 30;

    madnes_add_img('bigwin_label', 'bigwin_label', -10, -100, 1, 0.5, 0.5);
    madnes_add_img('megawin_label', 'megawin_label', -10, -100, 1, 0.5, 0.5);
    madnes_add_img('supermegawin_label', 'supermegawin_label', -10, -100, 1, 0.5, 0.5);
    madnes_add_img('bonus_label', 'bonus_label', -10, -100, 1, 0.5, 0.5);

    madnes_add_img('bigwin_bg', 'bigwin_bg', main_phaser.width / 2 * multi + shiftBigWinX, main_phaser.height / 2 * multi + shiftBigWinY, 1, 0.5, 0.5); //text_wintype

    madnes_add_child('bigwin_bg', 'bigwin_label');
    madnes_add_child('bigwin_bg', 'megawin_label');
    madnes_add_child('bigwin_bg', 'supermegawin_label');
    madnes_add_child('bigwin_bg', 'bonus_label');

    madnes_set_visible("bigwin_bg", false);
    hide_all_bigwin_texts();

    madnes_add_bitmap_text('windesk_sum', 'bigwin_fonts', wi / 2 + shiftBigWinX - 10, he / 2 + 36 + shiftBigWinY, "", 80);
    madnes_set_img_center('windesk_sum', 0.5, 0.5);
    madnes_set_visible('windesk_sum', false);

    madnes_add_img("logo", "label", wi / 2, 6);
    madnes_set_img_center("logo", 0.5, 0);

    madnes_add_sprite("logo_anim", "logo_anim_json", wi / 2, 6);
    madnes_set_img_center("logo_anim", 0.5, 0);
    madnes_anim_add("logo_anim", "anim", madnes_generate_frame_names("label_", 0, 42, "", 5));
    madnes_set_visible("logo_anim", false);
    madnes_set_pos("logo_anim", -9999, -9999);
    //madnes_anim_loop("logo_anim", "anim");

    madnes_add_img("freespins_text_label", "freespins_text_label", wi / 2, 115);
    madnes_set_img_center("freespins_text_label", 0.5, 0.5);
    madnes_set_visible("freespins_text_label", false);

    madnes_add_bitmap_text("freespins_text", "freespin_font", wi / 2 + 130, 49, "", 80);
    madnes_set_img_center("freespins_text", 1, 0);
    madnes_set_visible("freespins_text", false);

    madnes_add_img("winx2_label", "winx2_label", wi / 2, he / 2 + 40);
    madnes_set_img_center("winx2_label", 0.5, 0.5);
    madnes_set_visible("winx2_label", false);

    // madnes_recount_bet();

    madnes_audio_allow_multiple("reel_stop");
    madnes_audio_allow_multiple("reel_stop_joker_0");
}

export function hide_all_27()
{
    for(var i = 0; i <= 2; i++) {
        madnes_set_visible("win27_right_" + i, false);
        madnes_set_visible("win27_left_" + i, false);
    }
}

export function show_all_27()
{
    for(var i = 0; i <= 2; i++) {
        madnes_set_alpha("win27_right_" + i, 1);
        madnes_set_alpha("win27_left_" + i, 1);

        madnes_set_visible("win27_right_" + i, true);
        madnes_set_visible("win27_left_" + i, true);
    }
}

function hide_all_bigwin_texts() {
    madnes_set_visible('bigwin_label', false);
    madnes_set_visible('megawin_label', false);
    madnes_set_visible('supermegawin_label', false);
    madnes_set_visible('bonus_label', false);
}

export function show_bigwin_label(type) {
    hide_all_bigwin_texts();
    madnes_set_visible(type, true);
}

export function get_reel_symbol_name(reel, x, y)
{
    if(reel.length === 1) {
        reel = reel[0];
    }

    if(picture_convert[reel[x][y]] == "symbol_Bonus")
    {
        if(x == 2) {
            return "symbol_Bo";
        } else if(x == 1) {
            return "symbol_R";
        } else {
            return "symbol_Bonus";
        }
    }
    else
    {
        return picture_convert[reel[x][y]];
    }
}
